import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProtocolInfo } from "../../components/Protocols/ProtocolInfo";
import { ProtocolProvider } from "../../containers/Protocols/ProtocolContext/ProtocolProvider";
import { ExtraVisitTracking } from "../../containers/Protocols/TrackingExtra/ExtraVisit";
import VisitHeaderContainer from "../../containers/Protocols/VisitHeaderContainer";

export const ExtraVisitTrackingView = props => {
    const { match: { params: { protocolId, patientId, visitId } } } = props;

    return (
        <ProtocolProvider protocolId={protocolId}>
            <Row>
                <Col md={12} lg={12}>
                    <ProtocolInfo />
                </Col>
                <Col md={12}>
                    <VisitHeaderContainer protocolId={protocolId} patientId={patientId} />
                </Col>
                <Col md={12} lg={12}>
                    <ExtraVisitTracking protocolId={protocolId} patientId={patientId} visitId={visitId} />
                </Col>
            </Row>
        </ProtocolProvider>
    );
}